import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { ResultChip } from "src/atoms/PLPGrid";
import { useListingState } from "src/hooks/stores/use-listing-store";

export function ResultsChip(): JSX.Element | null {
  const { totalResults } = useListingState();
  const { i18n } = useLingui();

  if (!totalResults) {
    return null;
  }

  return (
    <ResultChip>
      {i18n.number(totalResults)}&nbsp;<Trans>results</Trans>
    </ResultChip>
  );
}
